import { useFormik } from 'formik'
import * as Yup from 'yup'
import { GENDER_LIST, RELATION_TYPE_LIST } from 'src/utils/constants/BuyPolicy'
import { LIFE_FORM_ERROR_MESSAGES } from 'src/utils/constants/BuyPolicyLife'
import SelectedIcon from 'src/assets/Buy_Policy_Images/selected.svg'
import { makeStyles } from '@material-ui/core/styles'
import { COLORS } from 'src/utils/Themes/colors'
import {
  Box,
  Button,
  Chip,
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import {
  getFormControlErrorText,
  isFormControlError,
} from 'src/services/formHelperService'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateBuyPolicyTitle } from 'src/actions'
import Modal from '@mui/material/Modal'
import InsuredMembersAgeSelector from 'src/components/BuyPolicy/insuranceScreens/life/modals/InsuredMembersAgeSelector'
import { addScroll, removeScroll } from 'src/utils/commonMethods'
import HealthInsuranceCarousel from 'src/components/BuyPolicy/insuranceScreens/health/HealthInsuranceCarousel'
import { BUY_POLICY_ANIMATION } from 'src/utils/constants/common'
import { LIFE_FORMIK_KEYS } from 'src/utils/constants/life'

const LifeUserDetails = () => {
  const classes = useStyles()
  const dispatch = useDispatch()

  let user = useSelector((state) => state?.userInfo)

  const [relationList, setRelationList] = useState([...RELATION_TYPE_LIST])
  const [isAgeSelectorModalOpen, setIsAgeSelectorModalOpen] = useState(false)
  const [formValues, setFormValues] = useState({})
  const setTitle = useSelector((state) => state?.buyPolicyTitle?.title)

  const initialStateValues = {
    gender: '',
    fullName: `${user?.userInfo?.userData?.firstName || ''} ${
      user?.userInfo?.userData?.lastName || ''
    }`,
    mobileNumber: user?.userInfo?.userData?.mobileNumber,
    email: user?.userInfo?.userData?.emailId,
    insuredRelation: [
      {
        label: 'Self',
        value: 'SELF',
        isSelected: true,
        dateOfBirth: '',
      },
    ],
    remarks: '',
    insuranceType: setTitle,
  }

  const updateRelationList = () => {
    const updatedList = relationList?.reduce((acc, item) => {
      const memberIndex = initialStateValues?.insuredRelation?.findIndex(
        (member) => member?.value === item?.value
      )
      acc?.push({ ...item, isSelected: memberIndex !== -1, dateOfBirth: '' })
      return acc
    }, [])

    setRelationList(updatedList)
  }

  useEffect(() => {
    updateRelationList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    return () => {
      dispatch(updateBuyPolicyTitle(''))
    }
  }, [dispatch])

  const lifeUserDetailsForm = useFormik({
    initialValues: initialStateValues,
    validationSchema: Yup.object({
      gender: Yup.string().required(LIFE_FORM_ERROR_MESSAGES?.GENDER_REQUIRED),
      fullName: Yup.string().required(
        LIFE_FORM_ERROR_MESSAGES?.FULL_NAME_REQUIRED
      ),
      email: Yup.string(),
      mobileNumber: Yup.string().required(
        LIFE_FORM_ERROR_MESSAGES?.MOBILE_REQUIRED
      ),
      insuredRelation: Yup.array()
        .of(
          Yup.object().shape({
            label: Yup.string(),
            value: Yup.string(),
            isSelected: Yup.boolean(),
            dateOfBirth: Yup.date(),
          })
        )
        .min(1, LIFE_FORM_ERROR_MESSAGES?.INSURED_MEMBERS_REQUIRED),
      remarks: Yup.string(),
      insuranceType: Yup.string().required(
        LIFE_FORM_ERROR_MESSAGES?.INSURANCE_TYPE
      ),
    }),
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true)
      handleSubmit(values)
    },
    enableReinitialize: true,
  })

  const handleGenderSelection = (item) => {
    lifeUserDetailsForm.setFieldValue(
      LIFE_FORMIK_KEYS?.GENDER,
      item?.enum,
      true
    )
  }

  const handleInsuredMembersSelect = (event, value) => {
    const selectedRelation = relationList?.find((item) => item?.value === value)

    const updatedList = [
      ...lifeUserDetailsForm?.values?.insuredRelation,
      selectedRelation,
    ]

    const relationItemIndex = relationList?.findIndex(
      (listItem) => listItem?.value === value
    )
    const updatedRelationList = [...relationList]
    updatedRelationList[relationItemIndex].isSelected = true
    setRelationList(updatedRelationList)

    lifeUserDetailsForm?.setFieldValue(
      LIFE_FORMIK_KEYS?.INSURED_RELATION,
      [...updatedList],
      true
    )
  }

  const handleInsuredMembersDelete = (event, value) => {
    event?.stopPropagation()
    const updatedList = [...lifeUserDetailsForm?.values?.insuredRelation]
    const selectedListItemIndex = updatedList?.findIndex(
      (listItem) => listItem?.value === value
    )
    updatedList?.splice(selectedListItemIndex, 1)

    const relationItemIndex = relationList?.findIndex(
      (listItem) => listItem?.value === value
    )
    const updatedRelationList = [...relationList]
    updatedRelationList[relationItemIndex].isSelected = false
    setRelationList(updatedRelationList)

    lifeUserDetailsForm?.setFieldValue(
      LIFE_FORMIK_KEYS?.INSURED_RELATION,
      [...updatedList],
      true
    )
  }

  const handleSubmit = (values) => {
    // dispatch(updateLifeUserDetails(values));  when taking age of users it's necessary, later development will come for this
    setFormValues(values)
    setIsAgeSelectorModalOpen(true)
  }

  const handleMobileNumberChange = (event) => {
    const onlyNums = event?.target?.value?.replace(/[^0-9]/g, '')
    event.target.value = Math.max(0, parseInt(onlyNums))
      ?.toString()
      ?.slice(0, 10)
    lifeUserDetailsForm?.handleChange(event)
  }

  return (
    <>
      {isAgeSelectorModalOpen ? (
        <Modal
          open={isAgeSelectorModalOpen}
          onClose={() => setIsAgeSelectorModalOpen(false)}
          id='errorModal'
        >
          <div className={`modal-container ${classes.modalRoot}`}>
            <InsuredMembersAgeSelector
              handleClose={() => setIsAgeSelectorModalOpen(false)}
              formValues={formValues}
            />
          </div>
        </Modal>
      ) : null}
      <div className={classes.root}>
        <div className={classes.buyInsurance}>
          <div className={classes.imageContainer}>
            <div className={classes.corouselContainer}>
              <HealthInsuranceCarousel />
            </div>
            <div className={classes.objectsImage}>
              <iframe
                src={BUY_POLICY_ANIMATION}
                frameBorder='0'
                allowFullScreen
                className={classes.iframe}
              />
            </div>
          </div>
          <div className={classes.formMainContainer}>
            <div className={classes.userDetailsFromRoot}>
              {!lifeUserDetailsForm?.values?.gender && (
                <div className={classes.errorText}>
                  {LIFE_FORM_ERROR_MESSAGES?.GENDER_REQUIRED}
                </div>
              )}
              <div className={classes.genderOptionsContainer}>
                {GENDER_LIST?.map((genderListItem) => {
                  return (
                    <div
                      key={genderListItem?.label}
                      id={`genderListItem_${genderListItem?.enum}`}
                      className={classes.genderSelector}
                      onClick={() => handleGenderSelection(genderListItem)}
                    >
                      <img
                        src={genderListItem?.icon}
                        alt={genderListItem?.label}
                        className={classes.genderImage}
                      />
                      <span className={classes.genderLabel}>
                        {genderListItem?.label}
                      </span>
                      {genderListItem?.enum ===
                        lifeUserDetailsForm?.values?.gender && (
                        <div className={classes.genderSelected}>
                          <img
                            src={SelectedIcon}
                            alt='Gender Selected'
                            className={classes.genderSelectedImage}
                          />
                        </div>
                      )}
                    </div>
                  )
                })}
              </div>

              <div className={classes.formContainer}>
                <div className={classes.formFieldContainer}>
                  <FormControl className={classes.formFieldWidth}>
                    <TextField
                      size='small'
                      id='fullName'
                      name='fullName'
                      type='text'
                      label='Full Name'
                      placeholder='Full Name'
                      value={lifeUserDetailsForm?.values?.fullName}
                      onChange={lifeUserDetailsForm?.handleChange}
                      required
                      error={isFormControlError(
                        lifeUserDetailsForm,
                        'fullName'
                      )}
                      helperText={getFormControlErrorText(
                        lifeUserDetailsForm,
                        'fullName'
                      )}
                    />
                  </FormControl>

                  <FormControl className={classes.formFieldWidth}>
                    <TextField
                      id='mobileNumber'
                      size='small'
                      name='mobileNumber'
                      type='number'
                      label='Mobile Number'
                      placeholder='Mobile Number'
                      value={lifeUserDetailsForm?.values?.mobileNumber}
                      onChange={(event) => {
                        handleMobileNumberChange(event)
                      }}
                      required
                      error={isFormControlError(
                        lifeUserDetailsForm,
                        'mobileNumber'
                      )}
                      helperText={getFormControlErrorText(
                        lifeUserDetailsForm,
                        'mobileNumber'
                      )}
                    />
                  </FormControl>
                </div>

                <FormControl fullWidth>
                  <TextField
                    size='small'
                    id='email'
                    name='email'
                    type='email'
                    variant='outlined'
                    label='E-mail'
                    placeholder='Please enter Insurance to be covered'
                    value={lifeUserDetailsForm?.values?.email}
                    onChange={lifeUserDetailsForm?.handleChange}
                  />
                </FormControl>

                <FormControl fullWidth>
                  <span className={classes.insureText}>
                    Whom do you want to Insure?
                  </span>
                  <Select
                    id='insuredMemberSelect'
                    multiple
                    size='small'
                    displayEmpty
                    onOpen={() => {
                      removeScroll()
                    }}
                    onClose={() => {
                      addScroll()
                    }}
                    value={lifeUserDetailsForm?.values?.insuredRelation}
                    renderValue={(selected) => (
                      <Box className={classes.insuredMemberContainer}>
                        {selected &&
                          selected?.map((selectedRelation) => (
                            <Chip
                              key={selectedRelation?.value}
                              label={selectedRelation?.label}
                              onDelete={(event) =>
                                handleInsuredMembersDelete(
                                  event,
                                  selectedRelation?.value
                                )
                              }
                              onMouseDown={(event) => event?.stopPropagation()}
                            />
                          ))}
                      </Box>
                    )}
                    error={isFormControlError(
                      lifeUserDetailsForm,
                      'insuredRelation'
                    )}
                  >
                    {relationList &&
                      relationList?.map(
                        (relationListItem) =>
                          !relationListItem?.isSelected && (
                            <MenuItem
                              key={relationListItem?.value}
                              value={relationListItem?.value}
                              onClick={(event) =>
                                handleInsuredMembersSelect(
                                  event,
                                  relationListItem?.value
                                )
                              }
                            >
                              {relationListItem?.label}
                            </MenuItem>
                          )
                      )}
                  </Select>

                  {isFormControlError(
                    lifeUserDetailsForm,
                    'insuredRelation'
                  ) ? (
                    <FormHelperText className={classes.errorText}>
                      {getFormControlErrorText(
                        lifeUserDetailsForm,
                        'insuredRelation'
                      )}
                    </FormHelperText>
                  ) : null}
                </FormControl>
                <FormControl fullWidth>
                  <TextField
                    size='small'
                    id='insuranceType'
                    name='insuranceType'
                    type='text'
                    variant='outlined'
                    disabled={setTitle !== ''}
                    label='Insurance Type'
                    placeholder='Please enter Insurance to be covered'
                    value={lifeUserDetailsForm?.values?.insuranceType}
                    onChange={lifeUserDetailsForm?.handleChange}
                    required
                    error={isFormControlError(
                      lifeUserDetailsForm,
                      'insuranceType'
                    )}
                    helperText={getFormControlErrorText(
                      lifeUserDetailsForm,
                      'insuranceType'
                    )}
                  />
                </FormControl>
                <FormControl fullWidth>
                  <TextField
                    size='small'
                    id='remarks'
                    name='remarks'
                    type='text'
                    variant='outlined'
                    label='Remarks'
                    placeholder='Please mention your comments'
                    value={lifeUserDetailsForm?.values?.remarks}
                    onChange={lifeUserDetailsForm?.handleChange}
                    required
                    multiline
                    rows={2}
                  />
                </FormControl>
              </div>

              <div className={classes.actionsContainer}>
                <Button
                  variant='contained'
                  className={classes.viewPlansButton}
                  onClick={() => {
                    lifeUserDetailsForm?.handleSubmit()
                  }}
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default LifeUserDetails

const useStyles = makeStyles({
  root: {
    background: 'linear-gradient(185.98deg, #CEF3FF -18.56%, #FFFFFF 67.98%)',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    borderRadius: '10px',
  },
  corouselContainer: {
    width: '100%',
  },
  formFieldWidth: {
    width: '50%',
  },
  formFieldContainer: {
    width: '100%',
    display: 'flex',
    gap: '10px',
  },
  buyInsurance: {
    backgroundColor: 'white',
    // padding: '30px 5% 0px 5%',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // gap: '30px',
    flexDirection: 'column',
    width: '60%',
  },
  objectsImage: {
    width: '100%',
    // zIndex: 1,
  },
  iframe: {
    width: '100%',
    height: '350px',
  },

  userDetailsFromRoot: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',
    width: '100%',
  },
  genderOptionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    gap: '25px',
    padding: '20px',
  },
  optionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    gap: '15px',
    padding: '20px',
    '@media (max-width:1024px)': {
      flexWrap: 'wrap',
    },
  },
  genderSelector: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: COLORS.WHITE,
    padding: '20px',
    borderRadius: '10px',
    cursor: 'pointer',
    overflow: 'hidden',
    width: '75px',
    position: 'relative',
    boxShadow: '0px 5px 10px 0px #0000001A',
    gap: '10px',
    border: '1px solid #ffffff',
    '&:hover': {
      border: '1px solid #4dc3e3',
    },
  },
  genderSelected: {
    backgroundColor: '#4dc3e3',
    width: '30px',
    height: '30px',
    bottom: '-8px',
    right: '-8px',
    position: 'absolute',
    display: 'flex',
    borderTopLeftRadius: '18px',
  },
  genderSelectedImage: {
    width: '15px',
    height: '15px',
    padding: '5px',
  },
  genderImage: {
    height: '50px',
    width: '50px',
  },
  genderLabel: {
    fontSize: '14px',
  },
  formMainContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    width: '40%',
    padding: '30px',
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    width: '100%',
  },
  actionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
  },
  viewPlansButton: {
    backgroundColor: `${COLORS.DARK_PINK} !important`,
    textTransform: 'capitalize !important',
    width: '100%',
    borderRadius: '25px',
  },
  insureText: {
    fontSize: '14px',
    margin: '5px 0',
    color: `${COLORS.DARK_PINK} !important`,
    fontWeight: 'bold',
  },
  '@keyframes zoomEffect': {
    '0%': {
      transform: 'scale(1)',
    },
    '50%': {
      transform: 'scale(1.2)',
    },
    '100%': {
      transform: 'scale(1)',
    },
  },
  errorText: {
    color: '#d32f2f !important',
    fontSize: '12px',
    animation: '$zoomEffect 0.5s ease-in-out infinite',
  },
  modalRoot: {
    maxHeight: '90%',
    width: '50%',
    background: 'rgb(238, 238, 238)',
    borderRadius: '7px',
    padding: '10px',
    maxWidth: '500px',
  },
  insuredMemberContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 0.5,
  },
})
